import React from 'react';
import { render } from 'react-dom';
import AppPlaceholder from 'app/Placeholder';
import { QueryClient, QueryClientProvider } from 'react-query';

import { LicenseInfo } from '@mui/x-license';
LicenseInfo.setLicenseKey('ed0cf5e0810ccae6715df4e7deb34478Tz0xMTgzNzksRT0xNzg4MDQ3OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=')


const App = React.lazy(() => import('app'));
const queryClient = new QueryClient();

const Root = () => (
  <React.Suspense fallback={<AppPlaceholder />}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.Suspense>
);

render(<Root />, document.getElementById('app'));
